module.exports = __webpack_public_path__ + "static/img/newplanning_title.57c00b79.png";